import { useEffect } from 'react';
import { useSearchParams, Link } from 'react-router-dom';
import { useLanguage } from '../contexts/LanguageContext';
import { Button } from '../components/ui/button';
import { Card, CardContent, CardHeader, CardTitle } from '../components/ui/card';
import { CheckCircle } from 'lucide-react';
import api from '../utils/axiosConfig';

const CheckoutSuccess = () => {
  const { t } = useLanguage();
  const [searchParams] = useSearchParams();
  const sessionId = searchParams.get('session_id');

  useEffect(() => {
    if (sessionId) {
      api.post('/api/stripe/verify-session', { sessionId })
        .then(() => window.dispatchEvent(new Event('planSubscriptionUpdated')))
        .catch((err) => {
          console.error('[CheckoutSuccess] verify-session failed:', err.response?.data?.error || err.message);
        });
    }
  }, [sessionId]);

  return (
    <div className='max-w-md mx-auto p-6'>
      <Card>
        <CardHeader>
          <CardTitle className='flex items-center gap-2 text-green-600 dark:text-green-500'>
            <CheckCircle className='h-6 w-6' />
            {t('checkout.success')}
          </CardTitle>
        </CardHeader>
        <CardContent className='space-y-4'>
          <p className='text-sm text-muted-foreground'>
            {t('checkout.successMessage')}
          </p>
          {sessionId && (
            <p className='text-xs text-muted-foreground font-mono truncate'>
              {sessionId}
            </p>
          )}
          <Button asChild>
            <Link to='/dashboard'>{t('checkout.backToDashboard')}</Link>
          </Button>
        </CardContent>
      </Card>
    </div>
  );
};

export default CheckoutSuccess;
